define('NMSDesignSystem.SEO.Shopping', [
    'Facets.Browse.View', 'CMSadapter.Landing.View', 'ProductDetails.Full.View',
    'Profile.Model', 'Backbone', 'jQuery', 'Home.View', 'SC.Configuration', 'CMSadapter.Impl.Enhanced'
], function (FacetsBrowseView, CMSLandingView, ProductDetailsFullView, ProfileModule, Backbone, jQuery, HomeView, Configuration, CMSAdapterEnhanced) {
    'use strict';

    // Reviewed empty descriptions only. Existing authored metadata always wins.
    var descriptions = {
    "buyflushots.nmsincusa.com": {
        "/contact-us": "Contact Buy Flu Shots for help with flu vaccines, product availability, orders, and customer service. Find our phone, email, and location details.",
        "/about-us": "Learn about Buy Flu Shots, our company, and our work serving medical and healthcare customers.",
        "/flu-vaccine-reimbursement": "Compare 2026\u20132027 flu vaccine reimbursement information and product references, with links to official CMS vaccine pricing guidance.",
        "/products/animal-health/general-medications": "Browse general medications in the Buy Flu Shots animal health catalog. Compare individual item details and package information.",
        "/products/animal-health/medical-supplies-ah": "Browse medical supplies in the Buy Flu Shots animal health catalog. Review individual product details, sizes, and packaging.",
        "/products/animal-health": "Browse animal health products from Buy Flu Shots, including medications and medical supplies. Review individual product details and packaging.",
        "/products/ems": "Browse EMS products from Buy Flu Shots. Explore medications and medical supplies and review individual product details and packaging.",
        "/products/flu-vaccines/multi-dose-vials": "Browse flu vaccines supplied in multi-dose vials at Buy Flu Shots. Review individual vaccine details and package information.",
        "/products/flu-vaccines/pre-filled-syringes": "Browse flu vaccines supplied in pre-filled syringes at Buy Flu Shots. Review individual vaccine details and package information.",
        "/products/flu-vaccines/adult": "Browse the adult flu vaccine category at Buy Flu Shots. Review individual vaccine descriptions, presentations, and package information.",
        "/products/flu-vaccines": "Browse flu vaccines from Buy Flu Shots. Explore adult and pediatric categories, pre-filled syringes, and multi-dose vials, with individual product details.",
        "/products/flu-vaccines/pediatric": "Browse the pediatric flu vaccine category at Buy Flu Shots. Review individual vaccine descriptions, presentations, and package information.",
        "/products/medical-supplies": "Browse medical supplies from Buy Flu Shots. Explore the catalog and review individual product descriptions, sizes, and package details.",
        "/products/ppe": "Browse personal protective equipment (PPE) from Buy Flu Shots. Review individual product descriptions, sizes, and package information.",
        "/products/prescription-medication": "Browse prescription medications from Buy Flu Shots. Review individual product descriptions, strengths, presentations, and package information.",
        "/products/other-vaccine": "Browse the vaccine catalog at Buy Flu Shots. Review individual vaccine descriptions, presentations, and package details.",
        "/products/vaccine-supplies": "Browse vaccine supplies from Buy Flu Shots. Review individual product descriptions and packaging to find supplies for your practice.",
        "/returns": "Review Buy Flu Shots return policies and instructions before requesting a product return.",
        "/shipping": "Review Buy Flu Shots shipping information, delivery policies, and guidance for your order.",
        "/products": "Browse the Buy Flu Shots product catalog. Explore product categories and review item details to find the supplies you need."
    },
    "nmsincusa.com": {
        "/about-us": "Learn about Nationwide Medical Surgical, our company, and our work serving medical and healthcare customers.",
        "/contact-us": "Contact Nationwide Medical Surgical for help with products, orders, and customer service. Find our phone, email, and location details.",
        "/privacy-policy": "Read the Nationwide Medical Surgical privacy policy for information about how this website collects, uses, and protects personal information.",
        "/products/animal-health/best-sellers": "Browse featured animal health products from Nationwide Medical Surgical. Review product details, catalog identifiers, and package information.",
        "/products/animal-health/controlled-medications": "Browse controlled medications in the Nationwide Medical Surgical animal health catalog. Review individual item details and package information.",
        "/products/animal-health/general-medications": "Browse general medications in the Nationwide Medical Surgical animal health catalog. Compare individual item details and package information.",
        "/products/animal-health/medical-supplies-ah": "Browse medical supplies in the Nationwide Medical Surgical animal health catalog. Review individual product details, sizes, and packaging.",
        "/products/animal-health/oncology-medications": "Browse oncology medications in the Nationwide Medical Surgical animal health catalog. Review individual item details and packaging.",
        "/products/animal-health": "Browse animal health products from Nationwide Medical Surgical, including medications and medical supplies. Review individual product details and packaging.",
        "/products/crash_cart": "Browse crash cart products from Nationwide Medical Surgical. Review individual medications and supplies, catalog identifiers, and package details.",
        "/products/ems": "Browse EMS products from Nationwide Medical Surgical. Explore medications and medical supplies and review individual product details and packaging.",
        "/products/flu-vaccines/multi-dose-vials": "Browse flu vaccines supplied in multi-dose vials at Nationwide Medical Surgical. Review individual vaccine details and package information.",
        "/products/flu-vaccines/adult": "Browse the adult flu vaccine category at Nationwide Medical Surgical. Review individual vaccine descriptions, presentations, and package information.",
        "/products/flu-vaccines": "Browse flu vaccines from Nationwide Medical Surgical. Explore adult and pediatric categories, pre-filled syringes, and multi-dose vials, with individual product details.",
        "/products/health-beauty": "Browse health and beauty products from Nationwide Medical Surgical. Review individual item descriptions, sizes, and package details.",
        "/products/flu-vaccines/pediatric": "Browse the pediatric flu vaccine category at Nationwide Medical Surgical. Review individual vaccine descriptions, presentations, and package information.",
        "/products/flu-vaccines/pre-filled-syringes": "Browse flu vaccines supplied in pre-filled syringes at Nationwide Medical Surgical. Review individual vaccine details and package information.",
        "/products/medical-supplies": "Browse medical supplies from Nationwide Medical Surgical. Explore the catalog and review individual product descriptions, sizes, and package details.",
        "/products/ppe": "Browse personal protective equipment (PPE) from Nationwide Medical Surgical. Review individual product descriptions, sizes, and package information.",
        "/products/over-the-counter-medication": "Browse over-the-counter medications from Nationwide Medical Surgical. Review individual item descriptions, strengths, and package details.",
        "/products/other-vaccine": "Browse the vaccine catalog at Nationwide Medical Surgical. Review individual vaccine descriptions, presentations, and package details.",
        "/products/prescription-medication": "Browse prescription medications from Nationwide Medical Surgical. Review individual product descriptions, strengths, presentations, and package information.",
        "/products/vaccine-supplies": "Browse vaccine supplies from Nationwide Medical Surgical. Review individual product descriptions and packaging to find supplies for your practice.",
        "/products": "Browse the Nationwide Medical Surgical product catalog. Explore product categories and review item details to find the supplies you need.",
        "/returns": "Review Nationwide Medical Surgical return policies and instructions before requesting a product return.",
        "/shipping": "Review Nationwide Medical Surgical shipping information, delivery policies, and guidance for your order.",
        "/terms-conditions": "Read the Nationwide Medical Surgical terms and conditions governing use of this website and purchases."
    }
};
    // Distinct catalog items verified through read-only item metadata; never merge their URLs.
    var reviewedTitleIds = {"931": true, "1211": true, "1212": true, "1275": true, "1523": true, "2513": true, "2530": true, "2562": true, "2646": true, "3436": true, "3449": true, "4116": true, "4396": true, "4665": true, "5115": true, "5585": true, "5604": true, "5605": true, "5606": true, "5607": true, "5669": true, "5670": true, "5701": true, "5702": true, "5707": true, "5708": true, "5725": true, "5726": true, "5729": true, "5730": true, "5749": true, "5750": true, "9062": true, "9959": true, "10546": true, "10547": true, "10743": true, "11282": true};
    var ProfileModel = ProfileModule.ProfileModel || ProfileModule;

    // Match the flag encodings accepted by the existing product price gate.
    function enabled(value) {
        return value === true || value === 'T' || value === 'true' || value === 1 || value === '1';
    }
    function itemValue(view, field) {
        var item = view && view.model && view.model.get('item');
        return item && (item.get ? item.get(field) : item[field]);
    }
    function route(value) {
        return ('/' + String(value || '').replace(/^\//, '').split('?')[0]).replace(/\/$/, '') || '/';
    }
    function host() {
        var environment = typeof SC !== 'undefined' && SC.ENVIRONMENT;
        var hostname = String((environment && environment.currentHostString) ||
            (typeof window !== 'undefined' && window.location && window.location.hostname) || '').toLowerCase();
        if (hostname === 'sca-sandbox.ethanablatt.com') return 'nmsincusa.com';
        if (hostname === 'buyflu-sandbox.ethanablatt.com') return 'buyflushots.nmsincusa.com';
        return hostname;
    }
    function fallbackDescription(view) {
        var category = view.model && view.model.get('category');
        var path = category && category.get('fullurl');
        path = path || (view.model && (view.model.get('urlPath') || view.model.get('url')));
        path = path || (Backbone.history && Backbone.history.fragment);
        return (descriptions[host()] || {})[route(path)] || '';
    }
    function installDescription(View) {
        var proto = View && View.prototype;
        if (!proto || proto.nmsSEODescription) return;
        var original = proto.getMetaDescription;
        proto.getMetaDescription = function () {
            var authored = original ? original.apply(this, arguments) : this.metaDescription;
            return typeof authored === 'string' && authored.trim() ? authored : fallbackDescription(this);
        };
        proto.nmsSEODescription = true;
    }
    function installHome() {
        var proto = HomeView && HomeView.prototype;
        if (!proto || proto.nmsSEOHome) return;
        var originalTitle = proto.getTitle;
        var originalDescription = proto.getMetaDescription;
        proto.getTitle = function () {
            var authored = originalTitle ? originalTitle.apply(this, arguments) : '';
            return host() === 'buyflushots.nmsincusa.com' && (!authored || authored === 'Nationwide Medical Surgical')
                ? 'Buy Flu Shots | Flu Vaccines and Vaccine Supplies' : authored;
        };
        proto.getMetaDescription = function () {
            var authored = originalDescription ? originalDescription.apply(this, arguments) : '';
            return host() === 'buyflushots.nmsincusa.com' && (!authored || authored === 'Nationwide Medical Surgical Inc. (NMS) is an independent pharmaceutical wholesaler offering a wide range of FDA approved brand, generic and specialty prescription medications.')
                ? 'Shop flu vaccines, other vaccines, and vaccine supplies at Buy Flu Shots. Review product details and package information for your healthcare practice.' : authored;
        };
        proto.nmsSEOHome = true;
    }
    // Use published GTIN/UPC fields only. Item numbers and NDCs are not GTINs.
    function validGtin(value) {
        var code = String(value || '').trim();
        var sum = 0;
        var index;
        var weight = 3;
        if (!/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/.test(code) || /^0+$/.test(code)) return '';
        for (index = code.length - 2; index >= 0; index--) {
            sum += Number(code.charAt(index)) * weight;
            weight = weight === 3 ? 1 : 3;
        }
        return (sum + Number(code.charAt(code.length - 1))) % 10 === 0 ? code : '';
    }
    function usableSchemaPrice(value) {
        return (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) &&
            isFinite(Number(value)) && Number(value) >= 0;
    }
    function hasOfferPrice(offer) {
        if (!offer || typeof offer !== 'object') return false;
        var specification = offer.priceSpecification;
        // Retain the native single-price and range representations, including zero.
        return usableSchemaPrice(offer.price) || (specification &&
            (usableSchemaPrice(specification.price) ||
                (usableSchemaPrice(specification.minPrice) && usableSchemaPrice(specification.maxPrice))));
    }
    function installProduct() {
        var proto = ProductDetailsFullView && ProductDetailsFullView.prototype;
        if (!proto || proto.nmsSEOProduct) return;
        var originalTitle = proto.getTitle;
        proto.getTitle = function () {
            var title = originalTitle ? originalTitle.apply(this, arguments) : '';
            var sku = String(itemValue(this, 'itemid') || '').trim();
            return host() === 'nmsincusa.com' && reviewedTitleIds[String(itemValue(this, 'internalid'))] && sku && title && String(title).indexOf(sku) < 0
                ? title + ' | SKU ' + sku : title;
        };
        var originalJsonLd = proto.getJsonLd;
        if (originalJsonLd) {
            proto.getJsonLd = function () {
                var view = this;
                var args = Array.prototype.slice.call(arguments);
                // Native code modifies child JSON-LD; keep caller-owned data intact.
                if (args[0]) args[0] = jQuery.extend(true, {}, args[0]);
                return originalJsonLd.apply(view, args).then(function (nativeData) {
                    if (!nativeData) return nativeData;
                    var data = jQuery.extend(true, {}, nativeData);
                    var profile = ProfileModel.getInstance();
                    // The deployed storefront recognizes only the native authenticated 'T' value.
                    var loggedIn = profile.get('isLoggedIn') === 'T';
                    var priceGateActive = host() === 'buyflushots.nmsincusa.com' || enabled(Configuration.get('loginForPricing.active'));
                    var gated = priceGateActive && enabled(itemValue(view, 'custitem_awa_login_to_see_price'));
                    var name = itemValue(view, 'storedisplayname2') || itemValue(view, 'displayname') || itemValue(view, '_name');
                    var gtin = validGtin(itemValue(view, 'custitem_nms_gtin')) || validGtin(itemValue(view, 'upccode'));
                    // Retain an existing authored identifier; add no database lookup or catalog map.
                    if (gtin && !data.gtin && !data.gtin8 && !data.gtin12 && !data.gtin13 && !data.gtin14) {
                        data['gtin' + gtin.length] = gtin;
                    }
                    if (name) data.name = name;
                    if (!data.description || /^(undefined|null)\s*$/i.test(data.description)) delete data.description;
                    // Search data must not publish a price that the shopper cannot see.
                    // Preserve native price, currency, stock and pre-order logic otherwise.
                    if ((profile.hidePrices && profile.hidePrices()) || (gated && !loggedIn) ||
                            (data.offers && !hasOfferPrice(data.offers))) delete data.offers;
                    // Google Product snippets need an Offer, review or rating. Do not
                    // publish an incomplete Product when its price is unavailable or
                    // private. The layout separately retains WebPage/breadcrumb data.
                    if (data['@type'] === 'Product' && !data.offers &&
                            !data.review && !data.aggregateRating) return null;
                    return data;
                });
            };
        }
        proto.nmsSEOProduct = true;
    }
    var emptyResultsTag = '<meta name="robots" content="noindex, follow" data-nms-empty-results="true">';
    function hasEmptyFilteredResults(view) {
        var hostname = host();
        if (hostname !== 'nmsincusa.com' && hostname !== 'www.nmsincusa.com' &&
                hostname !== 'buyflushots.nmsincusa.com') return false;
        var model = view && view.model;
        var translator = view && view.translator;
        var items = model && model.get('items');
        if (!view.nmsSEOResultsReady || !model || !items ||
                items.length !== 0 || !translator) return false;
        var total = model.get('total');
        if (total === 0) {
            var keywords = translator.getOptionValue && translator.getOptionValue('keywords');
            return (typeof keywords === 'string' && keywords.trim() !== '') ||
                (Array.isArray(translator.facets) && translator.facets.length > 0);
        }
        // Old links can request pages beyond today's last result. Exclude only
        // a confirmed empty response whose native request starts past its total;
        // retain valid pages, empty categories, failed requests and native UX.
        if (typeof total !== 'number' || !isFinite(total) || total <= 0 ||
                Math.floor(total) !== total || typeof translator.getApiParams !== 'function') return false;
        try {
            var params = translator.getApiParams();
            // Native parsed ?show= values remain strings. Normalize only a full
            // decimal integer, without changing the translator or request data.
            var limit = params && params.limit;
            if (typeof limit === 'string' && /^[0-9]+$/.test(limit)) limit = Number(limit);
            return !!params && typeof limit === 'number' && isFinite(limit) &&
                limit > 0 && limit <= 9007199254740991 && Math.floor(limit) === limit &&
                typeof params.offset === 'number' && isFinite(params.offset) &&
                params.offset > 0 && params.offset <= 9007199254740991 &&
                Math.floor(params.offset) === params.offset &&
                params.offset % limit === 0 && params.offset >= total;
        } catch (error) {
            // Metadata must not break a page when its request cannot be certified.
            return false;
        }
    }
    function installEmptyResults() {
        var proto = FacetsBrowseView && FacetsBrowseView.prototype;
        if (!proto || proto.nmsSEOEmptyResults) return;
        var originalBefore = proto.beforeShowContent;
        var originalHead = proto.getAddToHead;
        proto.beforeShowContent = function () {
            var view = this;
            view.nmsSEOResultsReady = false;
            var result = originalBefore.apply(view, arguments);
            // Keep the native promise, callbacks, rejection and redirect behavior.
            if (result && typeof result.done === 'function') {
                result.done(function () { view.nmsSEOResultsReady = true; });
            }
            return result;
        };
        proto.getAddToHead = function () {
            var authored = originalHead.apply(this, arguments);
            return hasEmptyFilteredResults(this) && (!authored || typeof authored === 'string')
                ? (authored || '') + emptyResultsTag : authored;
        };
        // Native CMS can override getAddToHead with authored page content. Keep
        // the exclusion in its tracked head additions in either case, so route
        // destruction removes it and repeated enhancement cannot leave a copy.
        var adapterProto = CMSAdapterEnhanced && CMSAdapterEnhanced.prototype;
        var originalEnhance = adapterProto && adapterProto.enhancePage;
        if (originalEnhance && !adapterProto.nmsSEOEmptyResults) {
            adapterProto.enhancePage = function (view) {
                if (proto.isPrototypeOf(view) && view.nmsSEOEmptyResultNodes) {
                    view.nmsSEOEmptyResultNodes.forEach(function (node) { node.remove(); });
                    view.nmsSEOEmptyResultNodes = [];
                }
                var result = originalEnhance.apply(this, arguments);
                if (proto.isPrototypeOf(view) && hasEmptyFilteredResults(view) &&
                        Array.isArray(view.enhancedNodes)) {
                    var nodes = view.enhancedNodes.filter(function (node) {
                        return node.is && node.is('meta[data-nms-empty-results="true"]');
                    });
                    if (!nodes.length) {
                        var node = jQuery(emptyResultsTag);
                        node.appendTo(jQuery('head'));
                        view.enhancedNodes.push(node);
                        nodes.push(node);
                    }
                    view.nmsSEOEmptyResultNodes = nodes;
                }
                return result;
            };
            adapterProto.nmsSEOEmptyResults = true;
        }
        proto.nmsSEOEmptyResults = true;
    }
    function installCanonical(View) {
        var proto = View && View.prototype;
        if (!proto || !proto.getCanonical || proto.nmsSEOCanonical) return;
        var original = proto.getCanonical;
        proto.getCanonical = function () {
            var canonicalView = this;
            var translator = this.translator;
            var hostname = host();
            if ((hostname === 'nmsincusa.com' || hostname === 'www.nmsincusa.com' ||
                    hostname === 'buyflushots.nmsincusa.com') && translator &&
                    Array.isArray(translator.facets) && typeof translator.facetIsParameter === 'function') {
                // Page Generator drops facets supplied as query parameters, including
                // query links emitted by our UI for otherwise indexable path facets.
                // Preserve those facets when actually reached through their path URL.
                var fragment = String(Backbone.history && Backbone.history.fragment || '');
                var queryIndex = fragment.indexOf('?');
                var pathParts = (queryIndex < 0 ? fragment : fragment.slice(0, queryIndex)).split('/');
                var queryKeys = queryIndex < 0 ? [] : fragment.slice(queryIndex + 1).split('&').map(function (part) {
                    var key = part.split('=')[0];
                    try { return decodeURIComponent(key); } catch (e) { return key; }
                });
                var canonicalFacets = translator.facets.filter(function (facet) {
                    var isQueryFacet = queryKeys.indexOf(facet.id) >= 0 ||
                        (facet.url && queryKeys.indexOf(facet.url) >= 0);
                    var isPathFacet = pathParts.indexOf(facet.id) >= 0 ||
                        (facet.url && pathParts.indexOf(facet.url) >= 0);
                    return !translator.facetIsParameter(facet.id) && (!isQueryFacet || isPathFacet);
                });
                if (canonicalFacets.length !== translator.facets.length) {
                    canonicalView = Object.create(this);
                    canonicalView.translator = Object.create(translator);
                    canonicalView.translator.facets = canonicalFacets;
                }
            }
            var canonical = original.apply(canonicalView, arguments);
            if (typeof canonical !== 'string') return canonical;
            var hashIndex = canonical.indexOf('#');
            var hash = hashIndex < 0 ? '' : canonical.slice(hashIndex);
            var url = hashIndex < 0 ? canonical : canonical.slice(0, hashIndex);
            var queryIndex = url.indexOf('?');
            if (queryIndex < 0) return canonical;
            var params = url.slice(queryIndex + 1).split('&');
            var pages = params.filter(function (param) { return /^page=/.test(param); });
            // Only the redundant, unambiguous first page is normalized. Keep later
            // pages, indexable path facets, sort/search options, encoding and native host intact.
            if (pages.length !== 1 || pages[0] !== 'page=1') return canonical;
            var remaining = params.filter(function (param) { return param !== 'page=1'; });
            return url.slice(0, queryIndex) + (remaining.length ? '?' + remaining.join('&') : '') + hash;
        };
        proto.nmsSEOCanonical = true;
    }
    return {mountToApp: function () {
        installDescription(FacetsBrowseView);
        installCanonical(FacetsBrowseView);
        installEmptyResults();
        installDescription(CMSLandingView);
        installProduct();
        installHome();
    }};
});
